export const setOpenTasks = (state, response) => {
    state.activeTasks = response.tasks;
};

export const setCompletedTasks = (state, response) => {
    state.completedTasks = response.tasks;
};

export const setTasksLength = (state, response) => {
    state.all = response.totalCount;
};

export const setActive = (state, data) => {
    state.active = data;
};

export const setSelectedTasksFilter = (state, data) => {
    state.selectedTasksFilter = data;
};

export const setSelectedAppName = (state, data) => {
    state.selectedAppName = data;
};
